export default "__VITE_ASSET__DbBZ2Twd__"